import React, { useState, useEffect } from 'react';
import { obtenerClientes } from '../../services/clienteService';
import './casoForm.css';

const CasoForm = ({ casoInicial = {}, onSubmit, onCancel }) => {
  const [clientes, setClientes] = useState([]);
  const [formData, setFormData] = useState({
    clienteId: casoInicial.clienteId || '',
    tipoServicio: casoInicial.tipoServicio || 'compra',
    vehiculo: {
      marca: casoInicial.vehiculo?.marca || '',
      modelo: casoInicial.vehiculo?.modelo || '',
      placa: casoInicial.vehiculo?.placa || '',
      año: casoInicial.vehiculo?.año || '',
      precio: casoInicial.vehiculo?.precio || ''
    },
    notas: casoInicial.notas || ''
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    cargarClientes();
  }, []);

  const cargarClientes = async () => {
    try {
      const data = await obtenerClientes();
      setClientes(data);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.clienteId) newErrors.clienteId = 'Debe seleccionar un cliente';
    if (!formData.vehiculo.marca.trim()) newErrors['vehiculo.marca'] = 'La marca es requerida';
    if (!formData.vehiculo.placa.trim()) newErrors['vehiculo.placa'] = 'La placa es requerida';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length === 0) {
      onSubmit(formData);
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="caso-form">
      <h3>Datos del Caso</h3>
      
      <div className="form-group">
        <label>Cliente *</label>
        <select
          name="clienteId"
          value={formData.clienteId}
          onChange={handleChange}
          className={errors.clienteId ? 'error' : ''}
        >
          <option value="">Seleccione un cliente</option>
          {clientes.map(c => (
            <option key={c.id} value={c.id}>{c.nombre} - {c.documento}</option>
          ))}
        </select>
        {errors.clienteId && <span className="error-message">{errors.clienteId}</span>}
      </div>

      <div className="form-group">
        <label>Tipo de Servicio</label>
        <select name="tipoServicio" value={formData.tipoServicio} onChange={handleChange}>
          <option value="compra">Asesoria en Compra</option>
          <option value="venta">Asesoria en Venta</option>
          <option value="verificacion">Verificacion Legal</option>
          <option value="tramite">Tramite de Traspaso</option>
        </select>
      </div>

      <h4>Datos del Vehiculo</h4>
      
      <div className="form-row">
        <div className="form-group">
          <label>Marca *</label>
          <input
            type="text"
            name="vehiculo.marca"
            value={formData.vehiculo.marca}
            onChange={handleChange}
            className={errors['vehiculo.marca'] ? 'error' : ''}
            placeholder="Ej: Mazda, Renault, Chevrolet"
          />
        </div>
        <div className="form-group">
          <label>Modelo</label>
          <input
            type="text"
            name="vehiculo.modelo"
            value={formData.vehiculo.modelo}
            onChange={handleChange}
            placeholder="Ej: CX-30, Logan, Spark"
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Placa *</label>
          <input
            type="text"
            name="vehiculo.placa"
            value={formData.vehiculo.placa}
            onChange={handleChange}
            className={errors['vehiculo.placa'] ? 'error' : ''}
            placeholder="ABC123"
          />
        </div>
        <div className="form-group">
          <label>Anio</label>
          <input
            type="number"
            name="vehiculo.año"
            value={formData.vehiculo.año}
            onChange={handleChange}
            placeholder="2023"
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Precio del Vehiculo</label>
          <input
            type="number"
            name="vehiculo.precio"
            value={formData.vehiculo.precio}
            onChange={handleChange}
            placeholder="$"
          />
        </div>
      </div>

      <div className="form-group">
        <label>Notas Internas</label>
        <textarea
          name="notas"
          value={formData.notas}
          onChange={handleChange}
          rows="4"
          placeholder="Observaciones adicionales sobre el caso..."
        />
      </div>

      <div className="form-actions">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancelar
        </button>
        <button type="submit" className="btn-primary">
          {casoInicial.id ? 'Actualizar' : 'Crear'} Caso
        </button>
      </div>
    </form>
  );
};

export default CasoForm;